module.exports = __webpack_public_path__ + "img/nyc.569144f8.jpg";